
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [{
label: '商品名称：',
value: this.$route.params.G_NAME
},




{
label: '税 率 (%)：',
value: this.$route.params.Rate
},
{
label: '完税价格：',
value: this.$route.params.RatePrice
},
{
label: '计量单位：',
value: this.$route.params.EG_Unit
}
]
}
}



// WEBPACK FOOTER //
// ./src/components/EntryGoodsDetail.vue